import {useRouteError} from 'react-router-dom';
import React from "react";

export const ErrorPage: React.FC = () => {
    const error = useRouteError() as any;

    return (
        <div id={"error-page"}>
            <h1>Error Page</h1>
            <p>{error.statusText}</p>
            <p>{error.message}</p>
        </div>
    )
}